import React, {useContext, useState, useEffect, useRef} from 'react';
import _ from "lodash";
import "./classroomManagement.scss"
import {useHistory, withRouter} from "react-router-dom";
import {Formik, Form, Field, FieldArray} from "formik";
import { StoreContext } from '../../store/context'
import Paper from '@material-ui/core/Paper';
import { DatePicker } from "@material-ui/pickers";
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import FixedHeaderTable from '../../components/FixedHeaderTable';
import { makeStyles } from '@material-ui/core/styles';
import moment from 'moment';

const useStyles = makeStyles({
    table: {
        minWidth: 450,
    },
});


const columns = [
    { id: 'name', label: 'Student Name', minWidth: 170 },
    {
        id: 'programLvl',
        label: 'Program Level',
        minWidth: 100
    },
    {
        id: 'subjectName',
        label: 'Course',
        minWidth: 100
    },
    {
        id: 'phoneNo',
        label: 'Phone No.',
        minWidth: 170,
        align: 'right',
    },
    {
        id: 'schedule',
        label: 'Schedule',
        minWidth: 170,
        align: 'right',
    },
    {
        id: 'teacherName',
        label: 'Teacher',
        minWidth: 170,
        align: 'right',
    },
    {
        id: 'branch',
        label: 'Branch',
        minWidth: 170,
        align: 'right'
    }
];

const ClassroomManagementForm = () => {
    const classes = useStyles();
    const history = useHistory();
    const { state, actions } = useContext(StoreContext); // get global state and dispatch function
    const { getAllTeachers, getClassroom, displayAlertDialogWithMessage } = actions.generalActions;
    const { getAllCourses } = actions.registrationActions;
    const { teachers, classroom } = state.generalStates;
    const { courses } = state.registrationStates;
    const [programLvl, setProgramLvl] = React.useState(null);
    // schedule, subjectName, teacherName, programLvl
    const [schedule, setSchedule] = React.useState(null);
    const [teacherName, setTeacherName] = React.useState(null);
    const [course, setCourse] = React.useState(null);
    const [branch, setBranch] = React.useState(null);
    const [selectedDate, handleDateChange] = useState(moment());

    useEffect(() => {
        getAllCourses();
    }, []);

    const handleChange = (event) => {
        setProgramLvl(event.target.value);
    };

    const handleScheduleChange = (event) => {
        setSchedule(event.target.value);
    };

    const handleCourseChange = (event) => {
        setCourse(event.target.value);
    };

    const handleNameChange = (event) => {
        setTeacherName(event.target.value);
    };

    const handleBranchChange = (event) => {
        setBranch(event.target.value);
    };


    const handleSearchButton = () => {
        // if (schedule == null || course == null || programLvl == null){
        //     displayAlertDialogWithMessage("Oops", "Please enter all required info");
        //     return;
        // }
        const month = moment(selectedDate).format('MM-YYYY');
        getClassroom(schedule, course, teacherName, programLvl, month, branch);
    };

    const handleResetButton = () => {
        // if (schedule == null || course == null || programLvl == null){
        //     displayAlertDialogWithMessage("Oops", "Please enter all required info");
        //     return;
        // }
        setSchedule("");
        setProgramLvl("");
        setCourse("")
    };


    return (
        <div className="misc-student-payment-container">
            <h1 className="header">Classroom</h1>
            <div className="paperContainer">
                <FormControl className="form-control">
                    <DatePicker
                        style={{marginTop: "0px"}}
                        className="date-picker"
                        views={["year", "month"]}
                        label="Date"
                        value={selectedDate}
                        onChange={handleDateChange}
                    />
                </FormControl>
                <FormControl className="form-control">
                    <InputLabel id="program-lvl-label">Level</InputLabel>
                    <Select
                        labelId="program-lvl-label"
                        value={programLvl}
                        onChange={handleChange}>
                        <MenuItem value={1}>Remove</MenuItem>
                        <MenuItem value={2}>Form 1</MenuItem>
                        <MenuItem value={3}>Form 2</MenuItem>
                        <MenuItem value={4}>Form 3</MenuItem>
                        <MenuItem value={5}>Form 4</MenuItem>
                        <MenuItem value={6}>Form 5</MenuItem>
                        <MenuItem value={8}>Form 5 (Graduated)</MenuItem>
                    </Select>
                </FormControl>
                <FormControl className="form-control" size="small">
                    <InputLabel id="type-label">Schedule</InputLabel>
                    <Select
                        labelId="type-label"
                        value={schedule}
                        onChange={handleScheduleChange}>
                        <MenuItem value={"MORNING"}>Morning</MenuItem>
                        <MenuItem value={"AFTERNOON"}>Afternoon</MenuItem>
                    </Select>
                </FormControl>

                <FormControl className="form-control">
                    <InputLabel id="type-label">Course</InputLabel>
                    <Select
                        labelId="type-label"
                        value={course}
                        onChange={handleCourseChange}>
                        {
                            courses && courses.map((value, index) => {
                                return (
                                    <MenuItem key={value.id} value={value.id}>{value.name}</MenuItem>
                                );
                            })
                        }
                    </Select>
                </FormControl>
                <FormControl className="form-control">
                    <InputLabel id="branch-label">Branch</InputLabel>
                    <Select
                        labelId="branch-label"
                        value={branch}
                        onChange={handleBranchChange}>
                        <MenuItem value={'CHUNG_HWA'}>Chung Hwa</MenuItem>
                        <MenuItem value={'HENG_EE'}>Heng Ee</MenuItem>
                    </Select>
                </FormControl>
                <FormControl className="form-control">
                    <InputLabel id="type-label">Teacher</InputLabel>
                    <Select
                        labelId="type-label"
                        value={teacherName}
                        onChange={handleNameChange}>
                        {
                            teachers && teachers.map((value, index) => {
                                return (
                                    <MenuItem key={value.id} value={value.name}>{value.name}</MenuItem>
                                );
                            })
                        }
                    </Select>
                </FormControl>
                <br/>
                <Button className="search-btn" variant="contained" color="primary" onClick={handleSearchButton}>
                    Search
                </Button>

                <Button className="search-btn" variant="contained" color="primary" onClick={handleResetButton}>
                    Reset
                </Button>

                <div className="table-container">
                    {<FixedHeaderTable columns={columns} rows={classroom}/>}
                </div>

            </div>
        </div>
    )
}

export default withRouter(ClassroomManagementForm)
